var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-yellow-600 min-h-screen"},[_c('coming-soon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }